export class LineGraph {
    public date: Date;
    public jobId: string;
    public name: string;
    public graphValues: LineGraphData[];

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.date = json.date;
            this.jobId = json.jobId;
            if (json.graphValues && json.graphValues.length > 0) {
                this.graphValues = json.graphValues.map((valueJson: any) => new LineGraphData(valueJson));
            }
        }
    }
}
export class LineGraphData {
    public time: string;
    public freeTravelTime: number;
    public realTravelTime: number;
    public freetravelSpeed: number;
    public realTravelSpeed: number;
    public effectiveSpeed: number;
    public delay: number;

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.time = json.time;
            if (json.freeTravelTime) {
                this.freeTravelTime = +(json.freeTravelTime / 60).toFixed(2);
            } else {
                this.freeTravelTime = null;
            }

            if (json.realTravelTime) {
                this.realTravelTime = +(json.realTravelTime / 60).toFixed(2);
            } else {
                this.realTravelTime = null;
            }

            this.freetravelSpeed = json.freeTravelSpeed;
            this.realTravelSpeed = json.realTravelSpeed;
            this.effectiveSpeed = json.effectiveSpeed;

            if (this.freeTravelTime && this.realTravelTime) {
                this.delay = json.delay;
            } else {
                this.delay = null;
            }
        }
    }

    private addTimeZone(time: string): string {
        let parts = time.split(':');
        let timezoneOffset = new Date().getTimezoneOffset() / 60;
        let hour = parseInt(parts[0], 10);
        hour -= timezoneOffset;
        let hourstring = hour < 10 ? '0' + hour : hour;

        return hourstring + ':' + parts[1] + ':' + parts[2];
    }
}

export class LinegraphFormattedData {
    public formattedData: LgData;
    public xAxisLabels: string[];
    public type: string;
    public maximums: LinegraphMaxY;
}

export class LgData {
    public data: number[];
    public label: string;
}

export class LinegraphMaxY {
    public freeTravelTime: number;
    public realTravelTime: number;
    public freetravelSpeed: number;
    public realTravelSpeed: number;
    public effectiveSpeed: number;
    public delay: number;

    constructor() {
        this.freeTravelTime = 30;
        this.realTravelTime = 30;
        this.freetravelSpeed = 80;
        this.realTravelSpeed = 80;
        this.effectiveSpeed = 80;
        this.delay = 20;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/linegraphData.ts